import { GetPostsOutDto, Post } from "../../../types/post";

export const GET_DRAFT_POSTS = "GET_DRAFT_POSTS";
export const GET_DRAFT_POSTS_SUCCESS = "GET_DRAFT_POSTS_SUCCESS";
export const GET_DRAFT_POSTS_ERROR = "GET_DRAFT_POSTS_ERROR";
export const UPDATE_GET_DRAFT_POSTS = "UPDATE_GET_DRAFT_POSTS";
export const RESET_GET_DRAFT_POSTS = "RESET_GET_DRAFT_POSTS";

export interface GetDraftPosts {
  type: typeof GET_DRAFT_POSTS;
  payload: GetPostsOutDto;
}

export interface UpdateGetDraftPosts {
  type: typeof UPDATE_GET_DRAFT_POSTS;
  payload: Post[];
}

export interface GetDraftPostsError {
  type: typeof GET_DRAFT_POSTS_ERROR;
  payload: boolean | string;
}

export interface GetDraftPostsSuccess {
  type: typeof GET_DRAFT_POSTS_SUCCESS;
  payload: Post[];
}

export interface ResetGetDraftPosts {
  type: typeof RESET_GET_DRAFT_POSTS;
  payload: null;
}

export interface State {
  data: Post[] | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | GetDraftPosts
  | GetDraftPostsError
  | GetDraftPostsSuccess
  | UpdateGetDraftPosts
  | ResetGetDraftPosts;
